import React from 'react';
import {FrameContainer} from '../styledComponents/layout'

const Terms = () => (
  <FrameContainer>
    <section className="terms">
      <h1>利用規約</h1>
      <p>この規約（以下「本規約」といいます。）は、株式会社abasaku(以下「当社」といいます。)が提供するインターネットサービス「Flick!On!TV」(以下「本サービス」といいます。）の利用に関する条件を定めるものであり、本サービスを利用するすべてのお客様（以下「ユーザー」といいます。）に適用されます。ユーザーは、本サービスを利用する前に本規約をよくお読みください。</p>
      <h2>第１条 定義</h2>
      <p>本規約において、次の各号に掲げる用語の意義は、当該各号に定めるところによるものとします。</p>
      <p>（１）「コンテンツ」</p>
      <p>ユーザーが本サービスを通じてアクセスすることができる情報（文章、画像、動画、音声、音楽、イメージ、ソフトウェア、プログラム、コード等を指します）をいいます。</p>
      <p>（２）「提供コンテンツ」</p>
      <p>本サービスにおいて当社がユーザーに対し提供するコンテンツその他全ての情報をいいます。</p>
      <p>（３）「ユーザーコンテンツ」</p>
      <p>ユーザーが本サービスの利用にあたって入力または送信するコンテンツをいいます。</p>
      <p>（４）「番組動画」</p>
      <p>ユーザーが本サービス内で閲覧する動画コンテンツをいいます。</p>
      <h2>第２条 本規約への同意</h2>
      <p>１.ユーザーは、本規約の定めに従って本サービスを利用しなければならず、本規約に同意しない限り本サービスを利用できません。</p>
      <p>２.ユーザーが、本サービスをスマートフォンその他の情報端末にダウンロードし，本規約への同意手続を行った時点で、ユーザーと当社との間で、本規約の諸規定に従った利用契約（
        以下「本利用契約」といいます。）が成立するものとします。</p>
      <h2>第３条 未成年者による利用</h2>
      <p>１.未成年者のユーザーは、有償コンテンツの購入を含む本サービスの利用の一切につき、親権者等の法定代理人の同意を得た上で本サービスを利用し、法定代理人の同意のもと本サービスを利用しなければなりません。</p>
      <p>２.当社は末成年者のユーザーによる有償コンテンツの購入につき、年鈴に応じて利用金額の上限または支払方法等の制限を設けることがあります。未成年者のユーザーは当該制限に従って有償コンテンツを利用しなければなりません。</p>
      <p>３.末成年者のユーザーが、法定代理人の同意がないにもかかわらず同意があると偽りまたは年齢について成年と偽って本サービスを利用した場合、その他行為能力者あることを信じさせるために詐術を用いた場合、本サービスに関する一切の法律行為を取り消すことは出来ません。</p>
      <p>４.本規約の同意時に未成年であったユーザーが成年に達した後に本サービスを利用した場合、当該ユーザーは本サービスに関する一切の法律行為を追認したものとみなされます。</p>
      <h2>第４条 本規約の改定・変更</h2>
      <p>１.当社は、当社の判断において、いつでも本規約の内容を変更または追加できるものとします。変更後の利用規約は、当社が別途定める場合を除いて、本サービス上または、当社の運営するウェブサイトに提示します。</p>
      <p>2.ユーザーが本規約の変更後も本サービスの利用を継続する場合、当該ユーザーは、変更後の本規約に同意したものとみなされます。なお、当社は、本規約の変更または追加につき、各ユーザーに個別に通知することはいたしません。ユーザーは、本サービスをご利用するにあたっては、随時、本規約の最新の内容を御確認ください。</p>
      <h2>第５条 コンテンツについて</h2>
      <p>1.株式会社abasakuは、本コンテンツの元となる放送番組と同等の内容を提供することを保証しません。放送された番組であっても、著作権法上の理由その他の
        事情により本サービスでは提供をしない場合や、本サービスで提供した後であってもその提供を中止する場合があります。また、著作権法上の制限またはプライバシー保護等のため、放送番組の一部について編集または改変する場合があります。</p>
      <p>2.本コンテンツの視聴可能期間は種類や内容により異なります。</p>
      <p>3.お客様は、利用料、利用期間等の利用条件が別途定められた本サービスを利用する場合、かかる利用条件に従うものとします。本サービスの画面上で「購入」、「販売」などの表示がされている場合であっても、当社がお客様に対し提供する本コンテンツに関する知的財産権その他の権利はお客様に移転せず、お客様には、上記の利用権のみが付与されます。</p>
      <h2>第6条 通信の秘密</h2>
      <p>当社は、電気通信事業法第４条に基づき、ユーザーの通信の秘密を守ります。ただし、次の各号のいずれか一つに該当する場合、当社は、当該各号に定める範囲内において、ユーザーの通信の秘密にかかわる情報を閲覧または削除することができるものとします。</p>
      <p>（１）刑事訴訟法または犯罪捜査のための通信傍受に関する法律の定めに基づく強制処分または裁判所の命令が行われた場合</p>
      <p>（２）法令に基づく行政処分が実施された場合</p>
      <p>（３）特定電気通信役務提供者の損害賠償責任の制限及び発信者情報の開示に関する法律第４条に基づく開示請求の要件が満たされていると当社が判断した場合</p>
      <p>（４）人の生命、身体または財産の保護のために必要があると当社が判断した場合</p>
      <p>（５）本サービス運営上やむを得ないと当社が判断した場合</p>
      <p>（６）ユーザーの同意を取得した場合</p>
      <h2>第7条 ユーザーに関する情報の取扱い</h2>
      <p>当社は、ユーザー情報、端末情報等その他本サービスの利用に関しユーザーから収集する情報を、別途当社が定めるFlick!On!TVプライバシーポリシーに従い、適切に取り扱います。</p>
      <h2>第8条 アカウントの管理</h2>
      <p>１.ユーザーは、自己の責任においてアカウントを管理及び保管するものとし、これを第三者に利用させ、または貸与、護渡、名義変更、売買等をしてはならないものとします。</p>
      <p>２.当社は、当該アカウントの一致を確認した場合、当核アカウントを保有するものとして登録されたユーザーが本サービスを利用したものとみなします。</p>
      <p>３.アカウントが盗用されまたは第三者に使用されていることが判明した場合、ユーザーは、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。</p>
      <p>４.アカウントの管理不十分または第三者の使用等による損害の責任は、ユーザーが負うものとし、当社は一切の責任を負いません。</p>
      <p>5.当社は、最終のアクセスから1年以上経過しているアカウントを、あらかじめお客様に通知することなく削除することができます。</p>
      <h2>第9条 その他の情報の取得及び利用について</h2>
      <p>当社は、本サービスに付随するサービスの提供のために、当社が取得した情報のうち、個人情報に該当しない情報を統計情報としたものを第三者に提供できるものとします。</p>
      <h2>第10条 広告</h2>
      <p>当社は、本サービス内に当社または第三者の広告を掲載することができるものとします。</p>
      <h2>第11条 本サービスの利用</h2>
      <p>１.ユーザーは、当社の定める方法に従い、本サービスを利用するものとします。</p>
      <p>２.本サービスは、ユーザーが私的に使用する目的でのみ利用することができ、販売、配布または開発等の私的使用以外の目的で使用してはなりません。</p>
      <p>３.ユーザーは、本サービスを、当社が提供する状態でのみ利用するものとし、本サービスの複製、修正、変更、改変または翻案を行ってはなりません。</p>
      <p>４.本サービスを利用するために必要な情報端末、ソフトウェア、通信回線その他の通信環境等の準備及び維持は、ユーザーの費用と責任において行うものとします。</p>
      <p>５.本サービスの全部または一部について、年齢、本人確認の有無、ユーザー情報の有無、その他当社が必要と定める条件を満たしたユーザーに限り利用できる場合があり、ユーザーはあらかじめこれに同意するものとします。</p>
      <h2>第12条 禁止行為</h2>
      <p>１.ユーザーは、本サービスの利用にあたり、自らまたは第三者をして以下の名号のいずれかに該当する行為または該当するおそれのある行為をしてはなりません。</p>
      <p>1-1 法令、裁判所の判決、決定若しくは命令、または法令上拘束力のある行政措置に違反する行為またはこれらを助長する行為</p>
      <p>1-2 当社または他のユーザーその他の第三者に対する詐欺または脅迫行為</p>
      <p>1-3 公序良俗に反しまたは善良な風俗を害する行為</p>
      <p>1-4 当社または他のユーザーその他の第三者の知的財産権、肖像権、プライバシー、名誉、その他の権利または利益を侵害する行為</p>
      <p>1-5 本サービスの誤作動を誘引する行為</p>
      <p>1-6 本サービスが通常意図しないバグを利用する動作または通常意図しない効果を及ぼす外部ツールの利用、作成または頒布を行う行為</p>
      <p>1-7 本サービスまたは当社サーバー等に過度の負担をかける行為</p>
      <p>1-8 本サービスの内外を問わず、本サービス上のアカウントまたはコンテンツを第三者に有償で貸与、譲渡、売要等をする行為（いわゆるリアルマネートレード行為）</p>
      <p>1-9 前号に定める行為の申込みの誘引、申込み、承諾を含む一切の準備行為</p>
      <p>1-10 歩行中、車両運転中、その他の本サービスの利用が不適切な状況または慰様において本サービスを利用する行為</p>
      <p>1-11 以下に該当しまたは核当すると当社が判断した情報を本サービス上に送信• 投稿する行為</p>
      <p>ア 当社または第三者の著作権その他の知的財産権、肖像権、プライパシー、名誉、その他の権利または利益を侵害する情報</p>
      <p>イ ユーザーを特定可能な個人情報等を含む情報(但し、利用登録に必要な場合等当社が求めた場合、その他当社が認めた場合を除きます。）</p>
      <p>ウ 過度にわいせつな表現（性的な事物を連想させると当社が判断した表現をいい、芸術性の有無を問いません。)を含む情報</p>
      <p>エ 異性、同性を問わず、面識のない第三者との出会いまたはわいせつな行為等を目的とする情報</p>
      <p>オ 自殺、自傷行為を誘引、勧誘または助長するまたは表現を含む情報</p>
      <p>力 薬物・危険ドラッグの売買に関する情報または薬物・危険ドラッグの不適切な利用を助長する表現を含む情報</p>
      <p>キ 宗教的行為、宗教団体、政治的活動、政治団体の宣伝または広告に関する情報</p>
      <p>ク 無限連鎖講、ネットワークビジネス関連の勧誘等に関する情報</p>
      <p>ケ ジャンクメール、スパムメールに相当する文面を含む情報</p>
      <p>コ 未成年者に悪影響を及ぼすおそれのある情報</p>
      <p>サ 残虚な表現その他他人に不快感を与えるおそれのある情報</p>
      <p>シ コンピュータウィルス等の有害なプログラムを流布させる情報</p>
      <p>ス その他当社が不適切と判断する愕報</p>
      <ol>
        <li><p>利用者は、本コンテンツを個人で視聴する目的に限って視聴し、以下の行為を自らまたは第三者を通じて行ってはいけません。</p></li>
        <li><p>本コンテンツを不特定または多数の人に視聴させる行為</p></li>
        <li><p>本サービスにより配信される映像、音声、文字等を著作権法で認められた私的利用の範囲を超えて、複製、出版、上映、譲渡、公衆送信、改変その他の態様で利用する行為</p></li>
      </ol>
      <p>5 本サービスまたは本コンテンツに施されているコンテンツ保護技術を改変その他の方法によって無効にする行為</p>
      <ol>
        <li><p>本サービスにおけるコンテンツ配信サービスの利用、レビュー機能の利用その他のサービス利用において、株式会社abasakuまたは第三者の知的財産権、プライバシー、肖像権等を侵害する行為</p></li>
        <li><p>株式会社abasakuの通信設備、コンピューターその他の機器およびソフトウェアに不正にアクセスし、または、それらの利用もしくは運用に支障を与える行為もしくはそのおそれのある行為</p></li>
        <li><p>本サービスがレビュー等の書き込み機能を有する場合において、利用者または第三者の営利を目的とする利用行為</p></li>
        <li><p>上記のほか、法令に違反する行為、本サービスの運営を妨害する行為、株式会社abasakuの信用を毀損する行為その他株式会社abasakuが不適当と判断する行為</p></li>
      </ol>
      <p>9-1 本サービスの内外を問わず、本サービスに関連するイべントの開催またはグッズの販売等、本サービスが意図しない方法で利益を得ることを目的とする行為</p>
      <p>9-2 本サービスを逆アセンブル，逆コンパイル、リバースエンジニアリング、その他本サービスのソースコードを解析する行為</p>
      <p>9-3 本サービスに接続しているシステムに権限なく不正にアクセスしまたは当社設備に蓄積された情報を不正に書き換え若しくは消去する行為</p>
      <p>9-4 本サービスを複製、送信、穣渡、貸与または改変する行為</p>
      <p>9-5 故意に虚偽のデータ等を公開しまたは投稿する行為</p>
      <p>9-6 不正な位置情報を登緑する行為</p>
      <p>9-7 当社または他のユーザーの情報の収集を目的とする行為</p>
      <p>9-8 当社または他のユーザーその他の第三者に成りすます行為</p>
      <p>9-9 他のユーザーのアカウントを利用する行為</p>
      <p>9-10 本サービス上での宜伝、広告または勧誘行為</p>
      <p>9-11 反社会的勢力等への利益供与行為</p>
      <p>9-12 その他当社が不適切と判断する行為</p>
      <h2>第13条 権利の帰属</h2>
      <p>１. 本サービス及び、本サービス内のアイテムその他の提供コンテンツに関する一切の知的財産権は、当社または当社にライセンスを許諾している者に帰属します。</p>
      <p>2.利用者は、当社が本サービス内で許諾する利用範囲を超えて、コンテンツを利用（転載・複製・修正・蓄積または転送等）してはならないものとします。なお、利用者は、当社がコンテンツの利用条件を必要に応じて変更する場合があること、及び当該利用条件の変更内容によっては、該当コンテンツの削除、利用停止等、当社が必要と判断する措置をとる場合があることを、あらかじめ承諾するものとします。</p>
      <p>３.ユーザーは、全ての提供コンテンツに関し、当社の故意または重過失以外の事由において損害を被った場合、当社に返金または補償を請求しないことに同意するものとします。</p>
      <p>４.本サービス上、商標、ブランドロゴ等（以下、総称して「商標等」といいます。)が表示される場合がありますが、当社はユーザーその他の第三者に対し、商標等を譲渡またはその利用を許諾するものではありません。</p>
      <h2>第14条 規約違反に対する措置</h2>
      <p>１.当社は、ユーザーが以下各号に該当しまたは該当するおそれがあると当社が判断した場合には、当社の裁量により、何らの通知も行うことなく、当核ユーザーに対し、ユーザーコンテンツその他の情報の全部若しくは一部の削除、本サービスの利用の一時停止若しくは制限、アカウントの削除を含む本利用契約の解除等の措置（以下「利用停止等」といいます。)を講じることができるものとします。</p>
      <p>1-1 本規約のいずれかの条項に違反した場合</p>
      <p>1-2 当社に提供された情報の全部または一部につき虚偽の事実があることが判明した場合</p>
      <p>1-3 ユーザーが支払停止若しくは支払不能となり、または破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合</p>
      <p>1-4 ユーザーが死亡しまたは後見開活、保佐開始若しくは補助開始の審判を受けた場合</p>
      <p>1-5 未成年者、成年被後見人、被保佐人または被補助人のいずれかであって、法定代理人、後見人、保佐人または補助人の同意等を得ていなかった場合</p>
      <p>1-6 当社からの問い合わせその他の回答を求める連絡に対して３０日間以上応答がない場合</p>
      <p>1-7 反社会的勢力等であるか、または資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等、反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合</p>
      <p>1-8 本サービスの運営、保守管理上必要であると当社が判断した場合</p>
      <p>1-9 その他前各号に類する事由があると当社が判断した場合</p>
      <p>２.ユーザーは、利用停止等の後も、当社及び第三者に対する本利用契約上の一切の義務及び債務（損害賠償債務を含みますが、これに限りません。）を免れるものではありません。</p>
      <p>３.当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について一切の責任を負わず、ユーザーのアカウント削除後も、当該ユーザーが当社に提供した情報を保有・利用することができるものとします。</p>
      <p>４.当社は、ユーザーが第１項各号に該当しまたは該当するおそれがあると当社が判断した場合その他当社が必要と認める場合には、ユーザーに対し、違反行為の中止、送信または投稿した情報の自発的な削除・訂正等を求めることがあり、ユーザーは、当社が定める期間内に当該求めに応じるものとします。</p>
      <p>５.当社は、本条に基づき当社が行った措置によりユーザーに生じた不利益や損害について一切の責任を負いません。</p>
      <h2>第１5条 損害賠償</h2>
      <p>１.ユーザーによる本規約違反行為その他本サービスの利用に起因して、当社に直接または間接の損害が生じた湯合（当該行為が原因で、当社が第三者から損害賠償請求その他の諸求を受けた場合を含みます。）、ユーザーは、当社に対し、その全ての損害（弁護士等専門家費用及び当社において対応に要した人件費相当額を含みます。）を賠償しなければなりません。</p>
      <p>２.本サービスの利用に関連してユーザーが被った損害につき、当社が、軽度の過失による債務不履行責任または不法行為責任を負う場合には、当社は、ユーザーに現実に発生した直接かつ通常の損害に限り、これを賠償する責任を負うものとし、特別な事情から生じた損害（損害の発生を予見しまたは予見し得た場合を含みます。）については、責任を負わないものとします。</p>
      <h2>第16条 秘密保持</h2>
      <p>１.ユーザーは、当社の事前の書面による承諾がある場合を除き、本サービスに関連して当社が秘密である旨指定した情報を秘密に取り扱うものとします。</p>
      <p>２.ユーザーは、当社から求められた場合はいつでも、当社の指示に従い、遅滞なく、前項の情報及び当該情報を記載または記録した書面その他の記録媒体物並びにその全ての複製物等を返却または廃棄しなければなりません。</p>
      <h2>第17条 本サービスの利用終了</h2>
      <p>１.ユーザーは、当社所定の方法により、いつでも本サービスの利用を終了することができます。本サービスの利用を終了したユーザーは、当該終了時点から本サービスを利用することができなくなります。</p>
      <p>2 .当社は、当社の裁量により、あらかじめ通知することなく、最終のアクセスから６か月以上経過しているアカウントを削除することができるものとします。</p>
      <h2>第18条 本サービスの変更・中断・終了等</h2>
      <p>１.当社は、ユーザーに事前に通知することなく、本サービスの内容の全部または一部を変更または追加することができるものとします。</p>
      <p>２.当社は、事前に、本サービス上または当社の運営するウェブサイト上への掲示その他の当社が適当と判断する方法でユーザーに通知することにより、当社の裁量で、本サービスの提供を終了することかできるものとします。</p>
      <p>３.当社は、以下の各号の事由が生じた場合には、ユーザーに事前に通知することなく、本サービスの全部または一部を一時的に中断することができるものとします。</p>
      <p>3-1 本サービス用の通信機器設備等に関わるメンテナンスや修理を定期的または緊急に行う場合</p>
      <p>3-2 アクセス過多、その他予期せぬ要因でシステムに負荷が莱中した場合</p>
      <p>3-3 ユーザーのセキュリティを確保する必要が生じた場合</p>
      <p>3-4 電気通信事業者の役務が提供されない場合</p>
      <p>3-5 地震、水害等の天災、火災、停電、その他の不慮の事故または戦争、紛争、動乱、暴動、労働争議等の不可抗力により本サービスの提供が困難な場合</p>
      <p>3-6 法令またはこれに基づく措置により本サービスの運営が不能となった場合</p>
      <p>3-7 その他前各号に準じ当社が必要と判断した場合</p>
      <p>４.当社は、本条に基づき当社が行った措置によりユーザーに生じた損害について一切の責任を負いません。</p>
      <h2>第19条 免責事項</h2>
      <p>１.当社は、本サービス及び本サービスを通じて提供されるコンテンツその他一切の情報につき、エラー、バグ、不具合またはセキュリティ上の欠陥が存しないこと、第三者の権利を侵害しないこと、ユーザーが期待する性質及び商品的価値を有すること、並びにユーザーに適用のある法令文は内部規則等に適合することについて、如何なる保証も行うものではありません。</p>
      <p>２.当社は本サービスが全ての情報端末に対応していることを保証するものではなく、本サービスの利用に供する情報端末のOSのバージョンアップ等に伴い、本サービスの動作に不具合が生じる可能性があることにつき、ユーザーはあらかじめ了承するものとします。当社は、かかる不貝合が生じた場合に当社が行うプログラムの修正等により、当該不具合が解消されることを保証するものではありません。</p>
      <p>3.本サービスに関し、ユーザー間またはユーザーと第三者との間で紛争が生じた場合、ユーザーは、当社にこれを通知の上、自己の責任と費用において解決するものとします。
        当社は、当該紛争に関与する義務を負わず、何ら責任を負わないものとします。</p>
      <h2>第20条 連絡及び問い合わせ</h2>
      <p>１.本サービスに関する当社からのユーザーヘの連絡に関しては、下記の方法で行います。</p>
      <p>1-1 本サービス上若しくは当社が運営するウェブサイト内の適宜の場所への掲示
        1-2 電子メールの送信
        1-3 その他当社が適当と判断する方法</p>
      <p>２.当社がユーザーへ電子メールの送信による通知を行った場合、当社から通知は、ユーザーが登録したメールアドレスへのメール送信し、それをユーザーが受信した時点で到達したものとみなします。</p>
      <p>３.本サービスに関する問い合わせは、当社が運営するウェブサイト内の対象となるお問い合わせフォームヘの送信その他、当社が指定する方法により行うものとします。</p>
      <h2>第21条 準拠法</h2>
      <p>本サービスその他の本規約に関する準拠法は日本法とします。</p>
      <h2>第22条 管轄裁判所</h2>
      <p>本サービスに関し、ユーザーと当社との間で訴訟が生じた場合、東京地方裁判所を第１審の専属的管轄裁判所とします。</p>
      <p>以上</p>
    </section>
  </FrameContainer>
);
export default Terms;



// WEBPACK FOOTER //
// ./src/pages/terms.js